const assetModules = import.meta.glob('../assets/**/*', {
    eager: true,
    import: 'default',
}) as Record<string, string>;

function normalizePath(path: string): string {
    if (!path) {
        return path;
    }

    let normalized = path;

    if (normalized.startsWith('@/assets/')) {
        normalized = normalized.substring('@/assets/'.length);
    } else {
        const assetsIndex = normalized.indexOf('assets/');
        if (assetsIndex >= 0) {
            normalized = normalized.substring(assetsIndex + 'assets/'.length);
        }
    }

    normalized = normalized.replace(/^(\.\/)+/, '');
    normalized = normalized.replace(/^(\.\.\/)+/, '');

    return normalized;
}

export function getAssetUrl(path: string): string {
    const normalized = normalizePath(path);
    const assetPath = `../assets/${normalized}`;
    const asset = assetModules[assetPath];

    if (!asset) {
        console.warn(`Asset not found for path: ${path}`);
        return '';
    }

    return asset;
}
